import { makeStyles } from "@material-ui/styles";
import customMuiComponentStyle from "../../../../../../style/customMuiComponentStyle";

export const useStyles = makeStyles({
  stopPivotButton: {
    ...customMuiComponentStyle.redButton
  }
});
